export const OPEN_SURVEY_MODAL = 'OPEN_SURVEY_MODAL';
export const CLOSE_SURVEY_MODAL = 'CLOSE_SURVEY_MODAL';
